<template>
  <LoadingBar ref="loadingBar" />
  <div class="w-full fixed top-0 border-b border-gray-200 dark:border-gray-700 z-10 bg-white dark:bg-black">
    <nav class="container mx-auto flex justify-between">
      <div class="max-w-screen-xl flex flex-wrap items-center justify-start max-xs:justify-center mx-auto py-4 gap-5">
        <router-link to="/fa" class="flex items-center space-x-3 rtl:space-x-reverse hover:opacity-75">
          <img src="@/assets/images/logo.png" class="w-10" alt="" />
          <img src="@/assets/images/text-logo.png" class="object-contain w-56" alt="" />
        </router-link>
        <nav class="hidden xl:flex gap-4">
          <router-link to="/fa"
            class="flex items-center justify-center hover:text-primary dark:hover:text-primary xl:justify-start refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa', 'text-gray-800 dark:text-white': $route.path !== '/fa' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">صفحه اصلی</span>
          </router-link>
          <router-link to="/fa/library"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/library', 'text-gray-800 dark:text-white': $route.path !== '/fa/library' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">کتابخانه</span>
          </router-link>
          <router-link to="/fa/posts"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/posts', 'text-gray-800 dark:text-white': $route.path !== '/fa/posts' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                fill="currentcolor" />
            </svg>
            <span class="mr-2 text-md">مقالات</span>
          </router-link>
          <router-link to="/fa/media"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/media', 'text-gray-800 dark:text-white': $route.path !== '/fa/media' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">آرشیو ویدیویی</span>
          </router-link>
          <router-link to="/fa/aboutus"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/aboutus', 'text-gray-800 dark:text-white': $route.path !== '/fa/aboutus' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" w-6 h-6">
              <path
                d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                fill="currentcolor" />
            </svg>
            <span class="mr-2 text-md">درباره ما</span>
          </router-link>
          <router-link to="/fa/contactus"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/contactus', 'text-gray-800 dark:text-white': $route.path !== '/fa/contactus' }">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" w-6 h-6">
              <path
                d="M12 3C7.593562 3 4 6.593562 4 11L4 12C2.9 12 2 12.9 2 14L2 16C2 17.1 2.9 18 4 18L6 18L6 13L6 12L6 11C6 7.674438 8.674438 5 12 5C15.325562 5 18 7.674438 18 11L18 12L18 13L18 18L18 19L13.912109 19 A 1.5 1.5 0 0 0 12.5 18 A 1.5 1.5 0 0 0 11 19.5 A 1.5 1.5 0 0 0 12.392578 20.994141 A 1.0001 1.0001 0 0 0 12.5 21L18 21C19.093063 21 20 20.093063 20 19L20 18C21.1 18 22 17.1 22 16L22 14C22 12.9 21.1 12 20 12L20 11C20 6.593562 16.406438 3 12 3 z"
                fill="currentcolor" />
            </svg>
            <span class="mr-2 text-md">تماس با ما</span>
          </router-link>
        </nav>
      </div>
      <button id="dropdownAvatarNameButton " data-dropdown-toggle="dropdownAvatarName"
        class="hover:opacity-75 flex items-center text-sm pe-1 font-medium rounded-full md:me-0 text-gray-400 dark:text-white"
        type="button">
        <span class="sr-only">Open user menu</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-translate w-5 h-5" viewBox="0 0 16 16">
          <path
            d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
          <path
            d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
        </svg>
      </button>
      <div id="dropdownAvatarName"
        class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-dim-900 dark:divide-gray-600">
        <div class="px-4 py-3 text-sm text-gray-900 dark:text-white">
          <div class="truncate">انتخاب زبان</div>
        </div>
        <ul class="py-2 text-sm text-gray-700 dark:text-gray-200"
          aria-labelledby="dropdownInformdropdownAvatarNameButtonationButton">
          <li>
            <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-dim-700 dark:hover:text-white"
              v-for="item in language" :key="item.id" link @click="setLanguage(item)"> {{ item.title }}</a>
          </li>
        </ul>
      </div>
      <div class="grid grid-cols-2 gap-2 items-center relative text-gray-800 dark:text-white">
        <span class="hidden xl:block mr-2 text-md">حالت شب</span>
        <label class="inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" class="sr-only peer" @change="toggleDarkMode" ref="darkModeCheckbox" />
          <div
            class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-greenrefah">
          </div>
        </label>
      </div>
    </nav>
  </div>
  <div class="mt-[70px] mb-10">
    <!-- //////////////////// -->
    <router-view v-slot="{ Component, route }">
      <transition name="fade">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
    <!-- /////////////////// -->
    <!-- <div class="xs:hidden fixed bottom-0 left-0 z-50 w-full h-12 bg-white dark:bg-black border-t border-gray-200 dark:border-gray-700 noprint">
      <div class="grid h-full max-w-lg grid-cols-5 mx-auto font-medium text-center">
        <router-link
          to="/fa"
          :class="{
            'text-primary': $route.path === '/fa',
            'text-gray-800 dark:text-white': $route.path !== '/fa',
          }"
        >
          <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
            <svg class="h-5 w-5" fill="none" viewBox="0 0 22 22">
              <path stroke="currentColor" stroke-width="1.833" d="m11.092 2.973 8.25 5.919v10.266h-4.859v-3.941c0-1.79-1.51-3.3-3.3-3.3-1.79 0-3.3 1.51-3.3 3.3v3.941H3.025V8.76l8.067-5.787Z"></path>
            </svg>
          </button>
        </router-link>
        <router-link
          to="/fa/posts"
          :class="{
            'text-primary': $route.path === '/fa/posts',
            'text-gray-800 dark:text-white': $route.path !== '/fa/posts',
          }"
        >
          <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
            <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24">
              <path fill="currentColor" d="m8.8 16.1 3.6 6.2c.2.4.8.6 1.2.3l3.1-1.8c.4-.2.6-.8.3-1.2L13.8 14l4.5-.3c.5 0 .9-.5.8-.9 0-.1-.1-.3-.1-.4L12.8 1.6c-.2-.4-.8-.6-1.2-.3l-.3.3-3.2 4.8-2.9 1.7c-2.1 1.2-2.9 3.9-1.6 6 1 1.9 3.2 2.7 5.2 2Zm6.3 3.7-1.5.9-3.1-5.4 1.5-.9 3.1 5.4Zm-9-10.2 3.1-1.8.3-.3L12 3.8l4.8 8.3-4.5.3c-.1 0-.3 0-.4.1l-3.1 1.8c-1.3.7-2.9.2-3.6-1-.8-1.4-.3-3 .9-3.7Zm14.4-5.2c1 1.7.4 3.9-1.3 4.9-.4.2-1 .1-1.2-.3-.2-.4-.1-1 .3-1.2.9-.5 1.1-1.6.7-2.4-.5-.9-1.6-1.1-2.4-.7-.4.2-1 .1-1.2-.3-.2-.4-.1-1 .3-1.2 1.6-1.1 3.8-.5 4.8 1.2Z"></path>
            </svg>
          </button>
        </router-link>
        <router-link
          to="/fa/media"
          :class="{
            'text-primary': $route.path === '/fa/media',
            'text-gray-800 dark:text-white': $route.path !== '/fa/media',
          }"
        >
          <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
            <svg class="h-5 w-5" fill="none" viewBox="0 0 28 28">
              <path fill="currentColor" fill-rule="evenodd" d="m10.945 17.28 7.963-4.513a.666.666 0 0 0 0-1.164l-7.963-4.512c-.457-.259-1.028.065-1.028.582v9.024c0 .518.571.841 1.028.582Zm4.257-5.095-2.951-1.672v3.345l2.951-1.673Z" clip-rule="evenodd"></path>
              <path fill="currentColor" fill-rule="evenodd" d="M3.996 2.625A2.552 2.552 0 0 0 1.46 5.177V18.74a2.552 2.552 0 0 0 2.552 2.552h19.98a2.552 2.552 0 0 0 2.551-2.553V5.178a2.552 2.552 0 0 0-2.537-2.552H3.996Zm-.204 2.847c0-.282.228-.514.514-.514h19.39c.285 0 .513.232.513.514v12.95c0 .281-.227.536-.513.536H4.306c-.286 0-.514-.255-.514-.536V5.472Z" clip-rule="evenodd"></path>
              <path fill="currentColor" d="M8.165 25.375v-2.333h11.669v2.333H8.165Z"></path>
            </svg>
          </button>
        </router-link>
        <router-link
          to="/fa/sound"
          :class="{
            'text-primary': $route.path === '/fa/sound',
            'text-gray-800 dark:text-white': $route.path !== '/fa/sound',
          }"
        >
          <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-mic w-6 h-6" viewBox="0 0 16 16">
              <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"></path>
              <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3"></path>
            </svg>
          </button>
        </router-link>
        <router-link
          to="/fa/asideHome"
          :class="{
            'text-primary': $route.path === '/fa/asideHome',
            'text-gray-800 dark:text-white': $route.path !== '/fa/asideHome',
          }"
        >
          <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
            <svg data-v-4686fdc4="" xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mail w-6 h-6" width="18" height="18" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path data-v-4686fdc4="" d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
            </svg>
          </button>
        </router-link>
      </div>
    </div> -->
  </div>

  <footer class="bg-white rounded-lg shadow dark:bg-black border-t border-gray-200 dark:border-gray-700">
    <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
      <div class="sm:flex sm:items-center sm:justify-between">
        <a href="https://binesheno.com/" class="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
          <img src="@/assets/images/logo.png" class="h-8" alt="Flowbite Logo" />
          <span
            class="self-center text-sm whitespace-nowrap text-white bg-primary p-2 rounded-tr-lg rounded-bl-lg">پایگاه
            اطلاع رسانی آیت الله مرتضی رضوی</span>
        </a>
        <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
          <li>
            <router-link to="/fa/aboutus" class="hover:underline me-4 md:me-6">درباره ما</router-link>
          </li>
          <li>
            <router-link to="/fa/contactus" class="hover:underline me-4 md:me-6">تماس با ما</router-link>
          </li>
          <li>
            <router-link to="/fa" class="hover:underline me-4 md:me-6">قوانین و مقررات</router-link>
          </li>
          <li>
            <router-link to="/fa" class="hover:underline">حریم خصوصی</router-link>
          </li>
        </ul>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 1404 <router-link to="/fa"
          class="hover:underline">بینش نو</router-link>. تمامی حقوق مادی و معنوی وبسایت، محفوظ
        است</span>
    </div>
  </footer>
  <button v-if="isVisible" @click="scrollToTop"
    class="text-sm fixed bottom-4 right-4 bg-primary text-white px-3 py-1 rounded-tr-lg rounded-bl-lg shadow-md transition transform hover:scale-110 dark:bg-primary"
    aria-label="Scroll to top">برگشت به بالا</button>

  <nav
    class="flex xl:hidden gap-4 fixed bg-white dark:bg-black border-t bottom-0 right-0 left-0 justify-around p-4 border-gray-200 dark:border-gray-700">
    <router-link to="/fa"
      class="flex items-center justify-center hover:text-primary dark:hover:text-primary xl:justify-start refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa', 'text-gray-800 dark:text-white': $route.path !== '/fa' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
        <path
          d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/library"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/library', 'text-gray-800 dark:text-white': $route.path !== '/fa/library' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
        <path
          d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/posts"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/posts', 'text-gray-800 dark:text-white': $route.path !== '/fa/posts' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
        <path
          d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
          fill="currentcolor" />
      </svg>
    </router-link>
    <router-link to="/fa/media"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/media', 'text-gray-800 dark:text-white': $route.path !== '/fa/media' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
        <path
          d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/aboutus"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/aboutus', 'text-gray-800 dark:text-white': $route.path !== '/fa/aboutus' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" w-8 h-8">
        <path
          d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
          fill="currentcolor" />
      </svg>
    </router-link>
    <router-link to="/fa/contactus"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/contactus', 'text-gray-800 dark:text-white': $route.path !== '/fa/contactus' }">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class=" w-8 h-8">
        <path
          d="M12 3C7.593562 3 4 6.593562 4 11L4 12C2.9 12 2 12.9 2 14L2 16C2 17.1 2.9 18 4 18L6 18L6 13L6 12L6 11C6 7.674438 8.674438 5 12 5C15.325562 5 18 7.674438 18 11L18 12L18 13L18 18L18 19L13.912109 19 A 1.5 1.5 0 0 0 12.5 18 A 1.5 1.5 0 0 0 11 19.5 A 1.5 1.5 0 0 0 12.392578 20.994141 A 1.0001 1.0001 0 0 0 12.5 21L18 21C19.093063 21 20 20.093063 20 19L20 18C21.1 18 22 17.1 22 16L22 14C22 12.9 21.1 12 20 12L20 11C20 6.593562 16.406438 3 12 3 z"
          fill="currentcolor" />
      </svg>
    </router-link>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import TheAside from "@/containers/TheAside.vue";
import TheSeccoundAside from "./TheSeccoundAside.vue";
import LoadingBar from "@/components/LoadingBar.vue";
export default {
  name: "TheContainer",
  components: {
    TheAside,
    TheSeccoundAside,
    LoadingBar,
  },
  data() {
    return {
      isVisible: false,
      languageId: null,
    };
  },
  computed: {
    ...mapGetters({
      language: "baseX/language",
    }),
    pageTitle() {
      return this.$route.meta.title || "حزب رفاه ملی افغانستان";
    },
    isInternalPage() {
      return this.$route.name !== "Home";
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route() {
      this.$refs.loadingBar.startLoading();
      setTimeout(() => {
        this.$refs.loadingBar.stopLoading();
      }, 1000);
    },
    language() {
      if (this.language && this.language.length > 0) {
        const find = this.language.find((z) => z.codeKey === this.$route.path.substring(1));
        if (find) {
          this.languageId = find.id;
          localStorage.setItem("languageId", find.id);
          this.reloadData();
        }
      }
    },
  },
  metaInfo: {
    titleTemplate: process.env.VUE_APP_BASE_TITLE,
    meta: [{ charset: "utf-8" }],
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    },
    toggleDarkMode(event) {
      if (event.target.checked) {
        document.querySelector("html").classList.add("dark");
        localStorage.setItem("darkMode", "enabled");
      } else {
        document.querySelector("html").classList.remove("dark");
        localStorage.setItem("darkMode", "disabled");
      }
    },
    setLanguage(data) {
      this.languageId = data.id;
      this.reloadData();
      localStorage.setItem("languageId", data.id);
      this.$router.push({
        name: "Home",
        params: { lang: data.codeKey },
      });
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight;
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 0;
      done();
    },

    reloadData() { },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$store.dispatch("baseX/getLanguage");
    const darkMode = localStorage.getItem("darkMode");
    if (darkMode === "enabled") {
      document.querySelector("html").classList.add("dark");
      this.$refs.darkModeCheckbox.checked = true;
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none !important;
  }
}
</style>
